// src/components/preparer-or-approver-only/PreparerOrApproverOnly.tsx
// Route guard: allows Preparer (Windvoice.Preparer), Approver (Windvoice.Approver), and Super Admin only.
import useSession from '@hooks/useSession';
import NotFound from '@components/not-found/NotFound';

interface PreparerOrApproverOnlyProps {
    readonly children: React.ReactNode;
}

const PreparerOrApproverOnly = ({ children }: PreparerOrApproverOnlyProps) => {
    const { isUser, isAdmin, isSuperAdmin, loading } = useSession();

    if (loading) {
        return <div>Loading...</div>;
    }

    if (!isUser && !isAdmin && !isSuperAdmin) {
        return <NotFound />;
    }

    return <>{children}</>;
};

export default PreparerOrApproverOnly;
